import { getFeatureFlagFromStorage } from './featureFlags.utils';
import { serializeForUri } from '../util';

export async function acquireTokenByPassword({ username, password }) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
  };

  const {
    CrossAppPromoCodeCarryOver: migrated,
  } = getFeatureFlagFromStorage();

  const tenant = process.env.REACT_APP_B2C_TENANT_URL;
  const customerScope = `https://${tenant}/pet-cloud/customer/customer.read`;

  const appScope = migrated
    ? customerScope
    : process.env.REACT_APP_B2C_CLIENT_ID;

  const bodyObject = {
    client_id: process.env.REACT_APP_B2C_CLIENT_ID,
    grant_type: 'password',
    password,
    response_type: 'token id_token',
    scope: `openid ${appScope} offline_access`,
    username,
  };
  const body = serializeForUri(bodyObject);

  const urlB2C = `https://${process.env.REACT_APP_B2C_URL}`
    + `/${process.env.REACT_APP_B2C_TENANT_URL}/`
    + `${process.env.REACT_APP_B2C_SIGNIN_NAME}/oauth2/v2.0/token`;
  try {
    const response = await fetch(urlB2C, {
      body,
      headers,
      method: 'POST',
    });
    const payload = await response.json();
    return payload;
  } catch (error) {
    return null;
  }
}
